import { render, staticRenderFns } from "./bookWrapper.vue?vue&type=template&id=17b3ec06&scoped=true&"
import script from "./bookWrapper.vue?vue&type=script&lang=js&"
export * from "./bookWrapper.vue?vue&type=script&lang=js&"
import style0 from "./bookWrapper.vue?vue&type=style&index=0&id=17b3ec06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b3ec06",
  null
  
)

export default component.exports